import BasePlugin from './BasePlugin';

export default class GoogleAdsPlugin extends BasePlugin {
    constructor(debug) {
        super(debug);
        this.trackingKey = 'gifty.gads_last';
    }

    initialize() {
        if (typeof gtag === 'undefined') {
            this.debug.log('info', 'Google Ads: gtag is not defined, aborting tracking');
            return false;
        }

        this.debug.log('gads', 'Google Ads plugin initialized');
        return true;
    }

    onOrderConfirmation(order) {
        if (order === null) {
            this.debug.log('gads', 'Order is null, aborting tracking.', 'Generally you\'ll see this message if the page has multiple instances of the order module and the event was already handled.');
            return;
        }

        if (sessionStorage.getItem('gifty.gads_last') === order.order_id) {
            this.debug.log('gads', 'Order already tracked, skipping.', 'Generally you\'ll see this message if the page has multiple instances of the order module and the event was already handled.');
            return;
        }

        let orderTotal = order.giftcards.reduce((total, giftcard) =>
            total + giftcard.value * giftcard.quantity, 0);

        // Register conversion event
        try {
            gtag('event', 'conversion', {
                send_to: window.Gifty.gads,
                value: orderTotal / 100,
                currency: 'EUR',
                transaction_id: order.order_id
            });
            sessionStorage.setItem('gifty.gads_last', order.order_id);
            this.debug.log('gads', 'Tracked order confirmation for order ID:', order.order_id);
        } catch (error) {
            this.debug.log('error', 'Google Ads tracking failed:', error);
        }
    }
}
